import debug from "debug";

// Export top-level namespace for debug logging so
// that we can separate the logs from other thridparty library debugs.
export const appDebug = debug("app");

export const debugNamespace = ["feature:timedEntry"] as const;

type DebugNamespace = typeof debugNamespace[number];

export function createDebug(namespace: DebugNamespace) {
  return appDebug.extend(namespace);
}

export const timeEntryDebug = createDebug("feature:timedEntry");
